// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lad-votes .el-button--text{color:#999}.lad-votes .el-button--text:hover,.lad-votes .el-button.is-disabled{color:#66b1ff}.lad-votes i{margin-right:5px}.lad-votes>span{margin-left:5px;font-size:13px;color:#999}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
